import React, { Component } from "react";
import { connect } from "react-redux";

import { createCompany } from '../../actions/session';
import { getHeader } from "../../helper";

class CreateEntity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isCreated: false,
        }
    }

    createCompany(e) {
        e.preventDefault();

        const { dispatch, session, handleCompany } = this.props;
        const { token, currentUser } = session;

        if(!token) return false;
        
        const ref = this.refs;

        const formData = new FormData();
        
        formData.append("title", ref.title.value);
        formData.append("full_title", ref.full_title.value);
        formData.append("inn", ref.inn.value);
        formData.append("ogrn", ref.ogrn.value);
        formData.append("kpp", ref.kpp.value);
        formData.append("bank_title", ref.bank_title.value);
        formData.append("bic", ref.bic.value);
        formData.append("schet", ref.schet.value);
        formData.append("korschet", ref.korschet.value);
        formData.append("ur_address", ref.ur_address.value);
        formData.append("fact_address", ref.fact_address.value);

        const config =  {
            "headers": getHeader()
        }

        dispatch(createCompany(
            formData,
            config,
            (data) => {
                this.setState({
                    isCreated: true
                }, () => {
                    
                    handleCompany({
                        value: data.id,
                        label: data.title,
                    });
                });
            }
        ));
    }

    render() {

        const { register, session, company:{companies} } = this.props;
        const { /*errorMessage,*/ creating } = companies;
        const { isCreated } = this.state;

        return (
            <div className="menu-content-entity menu-content-item tab-parent screen-bottom-block">
                {
                    isCreated
                    ?
                    <div className="rounded-white-block">
                        <div className="white-block-content">
                            <div className="sign-up-form-wrap">
                                <h4>Поздравляем!</h4>
                                <div className="you-responded text_green">Компания успешно зарегистрирована</div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="rounded-white-block">
                        <div className="white-block-top">
                            <h3>Данные организации</h3>
                        </div>

                        <div className="white-block-content">
                            <div className="sign-up-form-wrap">
                                <form onSubmit={this.createCompany.bind(this)}>
                                    <div className="sign-up-form-wrap__second" style={{marginTop: "0"}}>
                                        <div className="sign-up-form-wrap__inner">
                                            <input ref='title' type="text" required placeholder="Видимое (краткое) название" className="width100"/>
                                            <input ref='full_title' type="text" required placeholder="Наименование юридического лица" className="width100"/>
                                            <input ref='inn' type="text" required placeholder="ИНН" className="width100"/>
                                            <input ref='kpp' type="text" required placeholder="КПП" className="width100"/>
                                            <input ref='bic' type="text" required placeholder="БИК" className="width100"/>
                                            <input ref='ogrn' type="text" required placeholder="ОГРН" className="width100"/>
                                            <input ref='bank_title' type="text" required placeholder="Наименование банка" className="width100"/>
                                            <input ref='korschet' type="text" required placeholder="Кор. счёт" className="width100"/>
                                            <input ref='schet' type="text" required placeholder="Номер счёта" className="width100"/>
                                            <input ref='ur_address' type="text" required placeholder="Юридический адрес" className="width100"/>
                                            <input ref='fact_address' type="text" required placeholder="Фактический адрес" className="width100" style={{marginBottom: "30px"}}/>
                                        </div>
                                        <div className="big-button button-action width100">
                                            <button className={creating ? "disabled" : ""}>Зарегистрировать</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(CreateEntity);


// WEBPACK FOOTER //
// ./src/components/Account/CreateEntity.js